import OLandTransportSchedule from './o-land-transport-schedule.vue';

export default OLandTransportSchedule;